import { Fact } from "@/stores/mapping";

/** "A1:B2" 같은 범위 주소에서 시작 셀만 돌려준다. */
export function startAddress(address: string) {
  if (address?.includes(":")) {
    return address.split(":")[0];
  }
  return address;
}

export const parseCellAddress = (
  address: string,
): { column: string; row: number } => {
  const column: string = address.replace(/[0-9]/g, "").toUpperCase();
  const row: number = parseInt(address.replace(/[^0-9]/g, "")) || 0;
  return { column, row };
};

export const compareCellAddresses = (
  address1: string,
  address2: string,
): number => {
  const colComparison = compareColumns(address1, address2);
  const rowComparison = compareRows(address1, address2);
  if (rowComparison > 0) return 1;
  else if (rowComparison === 0 && colComparison > 0) return 1;
  else if (rowComparison === 0 && colComparison === 0) return 0;
  else return -1;
};

export const columnToNumber = (column: string): number => {
  let result = 0;
  const col = column.toUpperCase();

  for (let i = 0; i < col.length; i++) {
    result = result * 26 + (col.charCodeAt(i) - 64);
  }
  return result;
};

export const sortAddresses = (addresses?: string[]) => {
  if (!addresses) return [];
  return addresses.sort((a, b) => compareCellAddresses(a, b));
};

export const numberToColumn = (number: number): string => {
  let result = "";
  while (number > 0) {
    const remainder = (number - 1) % 26;
    result = String.fromCharCode(65 + remainder) + result;
    number = Math.floor((number - 1) / 26);
  }
  return result;
};

export const compareColumns = (address1: string, address2: string): number => {
  const column1 = parseCellAddress(address1).column;
  const column2 = parseCellAddress(address2).column;
  const address1Number = columnToNumber(column1);
  const address2Number = columnToNumber(column2);
  if (address1Number > address2Number) {
    return 1;
  } else if (address1Number < address2Number) {
    return -1;
  } else {
    return 0;
  }
};

export const compareRows = (address1: string, address2: string): number => {
  const address1Number = parseCellAddress(address1).row;
  const address2Number = parseCellAddress(address2).row;
  if (address1Number > address2Number) {
    return 1;
  } else if (address1Number < address2Number) {
    return -1;
  } else {
    return 0;
  }
};

export const buildCellLookupTable = (
  start: string,
  end: string,
  mergedCellAddresses: string[],
) => {
  const lookupTable = new Map<string, string>();
  const { column: startColumn, row: startRow } = parseCellAddress(start);
  const { column: endColumn, row: endRow } = parseCellAddress(end);

  for (let i = startRow; i <= endRow; i++) {
    for (
      let j = columnToNumber(startColumn);
      j <= columnToNumber(endColumn);
      j++
    ) {
      const cellAddress = `${numberToColumn(j)}${i}`;

      for (const mergedCell of mergedCellAddresses) {
        const [start, end] = mergedCell.split(":");
        const { column: mergedStartColumn, row: mergedStartRow } =
          parseCellAddress(start);
        const { column: mergedEndColumn, row: mergedEndRow } =
          parseCellAddress(end);
        if (
          i >= mergedStartRow &&
          i <= mergedEndRow &&
          j >= columnToNumber(mergedStartColumn) &&
          j <= columnToNumber(mergedEndColumn)
        ) {
          lookupTable.set(cellAddress, mergedCell);
          break;
        }
      }

      if (!lookupTable.has(cellAddress)) {
        lookupTable.set(cellAddress, cellAddress);
      }
    }
  }

  for (const mergedCell of mergedCellAddresses) {
    lookupTable.set(mergedCell, mergedCell);
  }

  return lookupTable;
};

export const factAddress = (fact: Fact) => {
  return `${fact.sheet.id}:${startAddress(fact.address)}`;
};
